import { Container, Grid, Typography, Card, CardContent } from '@mui/material';
import { Target, Building2, Trophy, CheckCircle2, Star } from 'lucide-react';
import getStyles from './styles';

const FellowshipStructure = () => {
  const styles = getStyles();

  const phases = [
    {
      phase: 1,
      badge: 'Phase 1',
      title: 'Discovery & Screening',
      duration: '2 Weeks',
      icon: Target,
      badgeStyle: styles.phaseBadgePrimary,
      dotStyle: styles.timelineDotPrimary,
      content: {
        // title: 'Work on real, market-ready products',
        items: [
          'Orientation',
          'Mini-problem solving task',
          'Self-driven challenge',
          'Video pitch',
          'Final interview'
        ]
        // outcome: 'Outcome: Shortlist Top 10 fellows',
        // outcomeStyle: styles.outcomeTitle
      }
    },
    {
      phase: 2,
      badge: 'Phase 2',
      title: 'The Builders Bootcamp',
      duration: '45 days',
      icon: Building2,
      badgeStyle: styles.phaseBadgePrimary,
      dotStyle: styles.timelineDotPrimary,
      reversed: true,
      content: {
        // title: 'Work on real, market-ready products',
        items: [
          'Work on real challenges and products',
          'Rapid, low-cost growth experiments',
          'Ownership of a small product area or feature',
          'Weekly reviews & mentorship with founders',
          'Tangible deliverables with measurable outcomes'
        ],
        outcome: 'Possible Outcomes:',
        offers: [
          'Shortlisted for Phase 3 (4 months Leadership)',
          'Stipend / compensation'
        ],
        outcomeStyle: styles.outcomeTitle
        // outcome: 'Outcome: Selection for 90-day fellowship',
        // outcomeStyle: styles.outcomeTitleGold
      }
    },
    {
      phase: 3,
      badge: 'Phase 3',
      title: '4 months Immersive Leadership Program',
      duration: '4 months',
      icon: Trophy,
      badgeStyle: styles.phaseBadgePrimary,
      dotStyle: styles.timelineDotPrimary,
      // quote: 'This is the real world.',
      content: {
        items: [
          'Full ownership of a product segment or growth channel',
          'Lead growth, community, or user engagement initiatives',
          'Weekly discussions with the founding team',
          'Deliver measurable product or growth results',
          'Operate as a core team member'
        ],
        outcome: 'Possible Outcomes:',
        offers: [
          'Co-founder track (for high-impact contributors)',
          'Leadership role in the product/growth/community team'
        ],
        outcomeStyle: styles.outcomeTitle
      }
    }
  ];

  return (
    <Grid sx={styles.section} id="structure">
      <Container maxWidth={'xl'}>
        <Grid sx={styles.container}>
          <Typography variant="h2" sx={styles.title}>
            Fellowship Structure
          </Typography>
          <Typography sx={styles.subtitle}>
            A 3-Phase Journey to Leadership
          </Typography>

          <Grid sx={styles.timelineContainer}>
            <Grid sx={styles.timelineLine} />

            {phases.map((phase, idx) => (
              <Grid key={idx} sx={styles.phaseContainer}>
                <Grid
                  sx={
                    phase.reversed
                      ? { ...styles.phaseRow, ...styles.phaseRowReversed }
                      : styles.phaseRow
                  }
                >
                  {/* Left Content */}
                  <Grid
                    sx={
                      phase.reversed
                        ? { ...styles.phaseContent, ...styles.phaseContentLeft }
                        : {
                            ...styles.phaseContent,
                            ...styles.phaseContentRight
                          }
                    }
                  >
                    <Typography
                      sx={{ ...styles.phaseBadge, ...phase.badgeStyle }}
                    >
                      {phase.badge}
                    </Typography>
                    <Typography variant="h3" sx={styles.phaseTitle}>
                      {phase.title}
                    </Typography>
                    <Typography sx={styles.phaseDuration}>
                      {phase.duration}
                    </Typography>
                    {phase.quote && (
                      <Typography sx={styles.phaseQuote}>
                        {phase.quote}
                      </Typography>
                    )}
                  </Grid>

                  {/* Timeline Dot */}
                  <Grid sx={{ ...styles.timelineDot, ...phase.dotStyle }}>
                    <phase.icon style={styles.timelineIcon} />
                  </Grid>

                  {/* Right Card */}
                  <Grid
                    sx={
                      phase.reversed
                        ? styles.cardContainerLeft
                        : styles.cardContainerRight
                    }
                  >
                    <Card
                      sx={
                        phase.badgeStyle === styles.phaseBadgeGold
                          ? { ...styles.phaseCard, ...styles.phaseCardGold }
                          : styles.phaseCard
                      }
                    >
                      <CardContent sx={styles.cardContent}>
                        {phase.content.title && (
                          <Typography sx={styles.cardTitle}>
                            {phase.content.title}
                          </Typography>
                        )}
                        <Grid component="ul" sx={styles.list}>
                          {phase.content.items.map((item, itemIdx) => (
                            <Grid
                              component="li"
                              key={itemIdx}
                              sx={styles.listItem}
                            >
                              <CheckCircle2
                                style={
                                  phase.badgeStyle === styles.phaseBadgeGold
                                    ? {
                                        ...styles.listIcon,
                                        ...styles.listIconGold
                                      }
                                    : styles.listIcon
                                }
                              />
                              <Typography component="span">{item}</Typography>
                            </Grid>
                          ))}
                        </Grid>
                        {(phase.content.outcome || phase.content.offers) && (
                          <Grid sx={styles.outcomeSection}>
                            {phase.content.outcome && (
                              <Typography
                                sx={{
                                  ...styles.outcomeTitle,
                                  ...phase.content.outcomeStyle
                                }}
                              >
                                {phase.content.outcome}
                              </Typography>
                            )}
                            {phase.content.offers && (
                              <Grid component="ul" sx={styles.starList}>
                                {phase.content.offers.map((offer, offerIdx) => (
                                  <Grid
                                    component="li"
                                    key={offerIdx}
                                    sx={styles.starItem}
                                  >
                                    <Star style={styles.starIcon} />
                                    <Typography component="span">
                                      {offer}
                                    </Typography>
                                  </Grid>
                                ))}
                              </Grid>
                            )}
                          </Grid>
                        )}
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Container>
    </Grid>
  );
};

export default FellowshipStructure;
